import { InstagramMessageModel } from "@jugl-web/rest-api/integrations/models/InstagramMessage/InstagramMessageModel";

export const isInstagramMessageDeleted = (message: InstagramMessageModel) =>
  "message" in message.payload &&
  "is_deleted" in message.payload.message &&
  message.payload.message.is_deleted;
